"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _setState = require("./setState");
Object.keys(_setState).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _setState[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _setState[key];
    }
  });
});
var _resetToUsernameAuth = require("./resetToUsernameAuth");
Object.keys(_resetToUsernameAuth).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _resetToUsernameAuth[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _resetToUsernameAuth[key];
    }
  });
});
var _resetToPhoneAuth = require("./resetToPhoneAuth");
Object.keys(_resetToPhoneAuth).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _resetToPhoneAuth[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _resetToPhoneAuth[key];
    }
  });
});
var _changeToPhoneAuth = require("./changeToPhoneAuth");
Object.keys(_changeToPhoneAuth).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _changeToPhoneAuth[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _changeToPhoneAuth[key];
    }
  });
});
var _changeToUsernameAuth = require("./changeToUsernameAuth");
Object.keys(_changeToUsernameAuth).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _changeToUsernameAuth[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _changeToUsernameAuth[key];
    }
  });
});
var _types = require("./types");
Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _types[key];
    }
  });
});